import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

// A user can hold multiple roles at once. True if they're admin (unrestricted)
// or hold any of the given roles.
export function hasRole(user, ...roles) {
  const userRoles = user?.roles || [];
  return userRoles.includes("admin") || roles.some((r) => userRoles.includes(r));
}

// Time fields are stored as 24-hour "HH:MM" strings (so backend string comparisons —
// e.g. the faculty double-booking overlap check — stay correct); this only formats
// them for display as 12-hour clock time with AM/PM.
export function formatTime12h(value) {
  const m = /^(\d{1,2}):(\d{2})$/.exec(value || "");
  if (!m) return value;
  const h = parseInt(m[1], 10);
  const meridiem = h >= 12 ? "PM" : "AM";
  const hour12 = h % 12 === 0 ? 12 : h % 12;
  return `${hour12}:${m[2]} ${meridiem}`;
}
